import { axios } from '@vyce/core/src/api';

import { FeedbackItem } from '../../types';

export const createFeedbackRequest = (token: string, feedback: FeedbackItem) => {
  return axios.post('/feedback', feedback);
};
